// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';


export async function getInsights(filterObj: Object = {}) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/all/dashboard`,
  }); 
  return response;
}

export async function getMonthlyOutstandingReport() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-outstanding`,
  }); 
  return response;
}

export async function sendMonthlyOutstandingReportEmail() {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-outstanding/send-email`,
    data: {},
  }); 
  return response;
}
